import { render, staticRenderFns } from "./NativeColorInput.vue?vue&type=template&id=16629810&"
import script from "./NativeColorInput.vue?vue&type=script&lang=ts&"
export * from "./NativeColorInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports